<template>
  <l-rows>
    <a-title
      :text="$t('support.openGameRounds')"
    />
    <open-game-round-list-search-form
      @casino-select="handleCasinoSelect"
      @submit="getOpenGameRounds"
    />
    <o-list
      :columns="columns"
      :data="openGameRounds"
      :loading="openGameRoundsMeta.loading"
      selectable
      @select="handleSelect"
    />
  </l-rows>
</template>

<script>
  import { ATitle, LRows, OList } from 'codefabrik-gui-vue'
  import { formatDateTime } from '@/shared'
  import { useGetOpenGameRounds } from '@/views/support/hooks'
  import OpenGameRoundListSearchForm from '@/components/opengameroundlist/OpenGameRoundListSearchForm'

  export default {
    name: 'OpenGameRoundList',
    components: {
      OpenGameRoundListSearchForm,
      LRows, ATitle, OList
    },
    data () {
      return {
        selectedCasinoId: null
      }
    },
    computed: {
      columns () {
        return [
          {
            header: this.$t('support.creationDate'),
            field: 'creationDate',
            filter: formatDateTime,
            size: 3
          },
          {
            header: this.$t('support.playerId'),
            field: 'playerId',
          },
          {
            header: this.$t('support.gameName'),
            field: 'gameName',
          },
        ]
      },
    },
    methods: {
      handleSelect (openGameRound) {
        this.$router.push({
          name: 'open-game-round',
          params: {
            casinoId: this.selectedCasinoId,
            openGameRoundId: openGameRound.id
          }
        })
      },
      handleCasinoSelect (casinoId) {
        this.selectedCasinoId = casinoId
      }
    },
    mixins: [
      useGetOpenGameRounds()
    ]
  }
</script>

<style scoped>

</style>
